import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useAuth } from '../../contexts/AuthContext';
import { certificateLabel } from '../../utils/certificateUtils';

// Pictures of the gymnast's certificates, newest level first.
export default function ChildCertificates() {
  const { user } = useAuth();
  const [certs, setCerts] = useState(null);
  const [images, setImages] = useState({});
  const [error, setError] = useState(null);

  useEffect(() => {
    Promise.all([axios.get(`/api/gymnasts/${user.id}`), axios.get('/api/levels')])
      .then(([g, l]) => {
        const levelById = new Map(l.data.map(level => [level.id, level]));
        setCerts((g.data.certificates || [])
          .map(c => ({ ...c, level: c.levelId ? levelById.get(c.levelId) : null }))
          .sort((a, b) => (b.level?.number ?? 0) - (a.level?.number ?? 0)));
      })
      .catch(() => setError('Could not load your certificates.'));
  }, [user.id]);

  useEffect(() => {
    if (!certs?.length) return undefined;
    let live = true;
    const urls = [];
    certs.forEach(c => {
      axios.get(`/api/certificates/${c.id}/preview`, { responseType: 'blob' })
        .then(res => {
          const url = URL.createObjectURL(res.data);
          urls.push(url);
          if (live) setImages(prev => ({ ...prev, [c.id]: url }));
        })
        .catch(() => {});
    });
    return () => { live = false; urls.forEach(u => URL.revokeObjectURL(u)); };
  }, [certs]);

  if (error) return <><p className="bk-error">{error}</p></>;
  if (!certs) return <div className="loading"><div className="spinner" /></div>;

  return (
    <>
      <h1 className="child-app__title">Certificates</h1>
      {certs.length === 0 ? <p>No certificates yet. You get one each time you complete a level, and sometimes for other achievements too.</p> : (
        <div className="child-certs">
          {certs.map(c => {
            const title = certificateLabel(c);
            return (
              <figure key={c.id} className="child-certs__item">
                {images[c.id]
                  ? <img src={images[c.id]} alt={`${title} certificate`} />
                  : <div className="child-certs__placeholder">Loading…</div>}
                <figcaption>{title}</figcaption>
              </figure>
            );
          })}
        </div>
      )}
    </>
  );
}
